import { render } from "./FeatureCreate.vue?vue&type=template&id=6de93c2c&ts=true"
import script from "./FeatureCreate.vue?vue&type=script&lang=ts"
export * from "./FeatureCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__